export const isAuctionOwner = (auction) => {
  if (!auction || !localStorage.auctionUser)
    return false

  return JSON.parse(localStorage.auctionUser).UserId === auction.OwnerId || localStorage.isAuctionSuperAdmin
}

// filters out collaborator (set in auction) vs. full admin (set in Cognito) irrespective of auction
export const isFullAdmin = () => {
  if (!localStorage.auctionUser)
    return false

  return !!localStorage.isAuctionAdmin
}

export const canEditAuction = (auction) => {
  if (!auction || !localStorage.auctionUser)
    return false

  const auctionUser = JSON.parse(localStorage.auctionUser)

  return auctionUser.UserId === auction.OwnerId
         || localStorage.isAuctionSuperAdmin
         || auction.Permissions.filter(permission => permission.Email === auctionUser.ContactEmail && permission.Level === 'Edit').length > 0
}

export const canCreateAuction = () => {
  if (!localStorage.auctionUser)
    return false

  return !!localStorage.isAuctionAdmin // only full admins can create auction (not localStorage.isAnyAdmin)
}

